import { render, staticRenderFns } from "./ModulesView.vue?vue&type=template&id=3f128159&scoped=true"
import script from "./ModulesView.vue?vue&type=script&lang=js"
export * from "./ModulesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f128159",
  null
  
)

export default component.exports